import { DeviceStatus, DeviceType } from '@/graphql/generated/schemas'

/**
 * Device types `DeviceDrawer` can actually render. It switches on type and
 * falls through to `null` for everything else, so opening it for an
 * unsupported type shows nothing *and* leaves `drawers.device.isOpen` stuck
 * true in persisted redux — with no visible drawer to close it.
 *
 * Callers must gate on this before dispatching `openDeviceDrawer`, and render
 * the affordance non-interactive when it returns false. Keep in sync with the
 * switch in `features/device-drawer/components/DeviceDrawer.tsx`.
 *
 * Lives here rather than in the device-drawer feature because six features
 * consume it, and importing that feature's barrel from `components/ui` closes
 * an import cycle back through `utils/analytics`.
 */
const DEVICE_DRAWER_SUPPORTED_TYPES: DeviceType[] = [
  DeviceType.Camera,
  DeviceType.Door,
]

export const isDeviceDrawerSupported = (
  type?: DeviceType | null
): type is DeviceType => !!type && DEVICE_DRAWER_SUPPORTED_TYPES.includes(type)

export const getDeviceStatusColor = (status: DeviceStatus) => {
  switch (status) {
    case DeviceStatus.Healthy:
      return 'brand.900'
    case DeviceStatus.Unhealthy:
      return 'incident.active.100'
    default:
      return '#888888'
  }
}
